<div class="myc-export-modal">
    <header class="myc-export-modal__header">
        <h2 class="myc-export-modal__title">{{ 'aumico_pdf_my_export_modal_title' | i18next }}</h2>
        <p class="myc-export-modal__subtitle">{{ 'aumico_pdf_my_export_modal_subtitle' | i18next }}</p>
    </header>

    <!--
        Two-column body. Left = tab-nav + scrollable tree, Right = settings
        accordions. Mirrors the print-preview controls layout from
        `aumico-lib-annualreport-fe/.../print-options.component.html` 1:1.
    -->
    <div class="myc-export-modal__body">
        <!-- ─── LEFT: tab nav + tree ─────────────────────────────────────── -->
        <section class="myc-export-modal__left">
            <ham-tab-navigation
                [navigationItems]="navigationItems"
                [tabsTitles]="tabsTitles"
                [style]="'underline'"
                [color]="'primary'"
                (tabClick)="onTabClick($event)"
            ></ham-tab-navigation>

            <!--
                Quick-select shortcuts. Text-link idiom (no border / no bg)
                so they read as secondary actions, not primary buttons.
                Scope = ACTIVE tab only. Smart toggle — label swaps based
                on `currentTabAllSelected`. Disabled in lock-step with the
                tree when the active tab's section is gated off in the
                right rail.
            -->
            <div
                class="myc-export-modal__quick-actions"
                [class.myc-export-modal__quick-actions--disabled]="currentTabDisabled"
            >
                <button
                    type="button"
                    class="myc-export-modal__shortcut"
                    [disabled]="currentTabDisabled"
                    (click)="onToggleSelectAllInActiveTab()"
                >
                    {{
                        (currentTabAllSelected
                            ? 'aumico_pdf_my_export_modal_deselect_all'
                            : 'aumico_pdf_my_export_modal_select_all'
                        ) | i18next
                    }}
                </button>
                <button
                    type="button"
                    class="myc-export-modal__shortcut"
                    [disabled]="currentTabDisabled"
                    (click)="onSelectGroupsInActiveTab()"
                >
                    {{ 'aumico_pdf_my_export_modal_select_groups' | i18next }}
                </button>
                <button
                    *ngIf="showSubTotalsShortcut"
                    type="button"
                    class="myc-export-modal__shortcut"
                    [disabled]="currentTabDisabled"
                    (click)="onSelectSubTotalsInActiveTab()"
                >
                    {{ 'aumico_pdf_my_export_modal_select_subtotals' | i18next }}
                </button>
            </div>

            <div
                class="myc-export-modal__tree"
                [class.myc-export-modal__tree--disabled]="currentTabDisabled"
            >
                <div
                    *ngFor="let row of visibleRows"
                    class="myc-export-modal__row"
                    [class.myc-export-modal__row--section]="row.kind === 'section'"
                    [class.myc-export-modal__row--group]="row.kind === 'group'"
                    [class.myc-export-modal__row--fli]="row.kind === 'fli'"
                    [class.myc-export-modal__row--sub]="row.kind === 'subFli'"
                    [class.myc-export-modal__row--subtotal]="row.kind === 'subTotal'"
                    [style.--row-level]="row.level"
                    (click)="onToggle(row)"
                >
                    <span
                        hamCheckbox
                        class="myc-export-modal__checkbox"
                        [checked]="isChecked(row)"
                        [bubbleEvents]="true"
                    ></span>
                    <span class="myc-export-modal__label">{{ row.label }}</span>
                </div>
            </div>
        </section>

        <!--
            ─── RIGHT: settings accordions ────────────────────────────────
            Structure copied verbatim from print-options.component.html so
            the visual idiom + behavior matches the print-preview page.
            `[isOpened]` is a constant initial-open marker — never mutated.
            Chevron icon swap is driven by `is*AccordionExpanded`, which is
            *set* (not flipped) by the (opened) / (closed) events. This
            decoupling is what prevents the init-loop the user observed.
        -->
        <aside class="myc-export-modal__right">
            <!-- Accordion 1: Bestandteile (BS / IS section toggles) -->
            <ham-accordion>
                <ham-accordion-item
                    (opened)="onComponentsAccordionOpened()"
                    (closed)="onComponentsAccordionClosed()"
                    [isOpened]="accordionInitialOpen"
                    #componentsAccordion
                >
                    <div accordion-header>
                        <span class="accordion-header-content">
                            <span
                                hamIconShapes
                                class="accordion-header-icon"
                                icon="assets/hamIcons/grid-outline.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                            ></span>
                            <span>{{ 'aumico_annual_report_print_options_components_accordion_title' | i18next }}</span>
                        </span>
                        <span class="accordion-icon">
                            <span
                                *ngIf="!isComponentsAccordionExpanded"
                                class="chevron-down"
                                hamIconShapes
                                icon="assets/hamIcons/chevron-down.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                (click)="componentsAccordion.onToggle()"
                            ></span>
                            <span
                                *ngIf="isComponentsAccordionExpanded"
                                hamIconShapes
                                class="chevron-up-outline"
                                icon="assets/hamIcons/chevron-up-outline.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                (click)="componentsAccordion.onToggle()"
                            ></span>
                        </span>
                    </div>
                    <div accordion-body>
                        <!--
                            Wrapper inside the accordion-body slot. We can't
                            reliably override `ham-accordion-item`'s own
                            `.accordion-item .accordion-body { padding: 0 20px !important }`
                            from outside (animation inline + Angular view-
                            encapsulation attributes make specificity ties go
                            their way). So we add our own padded wrapper here.
                        -->
                        <div class="myc-accordion-body-pad">
                            <div class="accordion-content">
                                <span>{{ 'aumico_analytics_controls_scope_balance' | i18next }}</span>
                                <span>
                                    <ham-toggle
                                        [checked]="includeBalance"
                                        (changed)="onToggleIncludeBalance($event)"
                                    ></ham-toggle>
                                </span>
                            </div>
                            <div class="accordion-content last-item">
                                <span>{{ 'aumico_analytics_controls_scope_income' | i18next }}</span>
                                <span>
                                    <ham-toggle
                                        [checked]="includeIncome"
                                        (changed)="onToggleIncludeIncome($event)"
                                    ></ham-toggle>
                                </span>
                            </div>
                        </div>
                    </div>
                </ham-accordion-item>
            </ham-accordion>

            <!-- Accordion 2: Weitere Einstellungen (Konten anzeigen) -->
            <ham-accordion>
                <ham-accordion-item
                    (opened)="onMoreSettingsAccordionOpened()"
                    (closed)="onMoreSettingsAccordionClosed()"
                    [isOpened]="accordionInitialOpen"
                    #moreSettingsAccordion
                >
                    <div accordion-header>
                        <span class="accordion-header-content">
                            <span
                                hamIconShapes
                                class="accordion-header-icon"
                                icon="assets/hamIcons/settings-wheel.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                            ></span>
                            <span>{{ 'aumico_annual_report_print_options_settings_accordion_title' | i18next }}</span>
                        </span>
                        <span class="accordion-icon">
                            <span
                                *ngIf="!isMoreSettingsAccordionExpanded"
                                class="chevron-down"
                                hamIconShapes
                                icon="assets/hamIcons/chevron-down.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                (click)="moreSettingsAccordion.onToggle()"
                            ></span>
                            <span
                                *ngIf="isMoreSettingsAccordionExpanded"
                                hamIconShapes
                                class="chevron-up-outline"
                                icon="assets/hamIcons/chevron-up-outline.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                (click)="moreSettingsAccordion.onToggle()"
                            ></span>
                        </span>
                    </div>
                    <div accordion-body>
                        <div class="myc-accordion-body-pad">
                            <div class="accordion-content">
                                <span>{{ 'aumico_annual_report_print_options_label_show_ratios' | i18next }}</span>
                                <span>
                                    <ham-toggle
                                        [checked]="showRatios"
                                        (changed)="onToggleShowRatios($event)"
                                    ></ham-toggle>
                                </span>
                            </div>
                            <div class="accordion-content last-item">
                                <span>{{ 'aumico_annual_report_print_options_show_accounts' | i18next }}</span>
                                <span>
                                    <ham-toggle
                                        [checked]="showAccounts"
                                        (changed)="onToggleShowAccounts($event)"
                                    ></ham-toggle>
                                </span>
                            </div>
                        </div>
                    </div>
                </ham-accordion-item>
            </ham-accordion>
        </aside>
    </div>

    <footer class="myc-export-modal__footer">
        <ham-button variant="white" outline="true" (buttonClick)="onCancel()">
            {{ 'aumico_pdf_my_export_modal_cancel' | i18next }}
        </ham-button>
        <ham-button variant="primary" [disabled]="exportDisabled" (buttonClick)="onConfirm()">
            {{ 'aumico_pdf_my_export_modal_confirm' | i18next }}
        </ham-button>
    </footer>
</div>
